// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';
import { FieldType } from '@databases/model/field';
import { type MutableValue } from '@databases/model/value';

import { MultiValueChangeType } from '../utils/collab-utils.ts';

export type SelectOptionChange =
  | {
      type: MultiValueChangeType.APPEND;
      value: { id?: string; label: string; color: string };
    }
  | { type: MultiValueChangeType.REMOVE; index: number }
  | { type: MultiValueChangeType.REORDER; currentIndex: number; newIndex: number }
  | { type: 'set_color'; index: number; color: string }
  | { type: 'update_label'; index: number; delta: any[] };

export function setSelectOptions(
  ydb: Database,
  fieldId: string,
  change: SelectOptionChange
): void {
  ydb.mutate((db) => {
    const field = db.fieldsById[fieldId];
    if (field) {
      switch (change.type) {
        case MultiValueChangeType.APPEND:
          field.selectOptions.add({
            id: change.value.id ?? change.value.label,
            label: change.value.label,
            color: change.value.color
          });

          break;

        case MultiValueChangeType.REMOVE: {
          const option = field.selectOptions.options[change.index].id;

          field.selectOptions.delete(change.index);

          db.entries.forEach((entryId) => {
            const value = db.entriesById[entryId].getValue(fieldId);

            if (value && value.type === FieldType.Select) {
              (value as MutableValue<FieldType.Select>).delete([option]);
            }
          });

          break;
        }

        case MultiValueChangeType.REORDER:
          field.selectOptions.reorder(change.currentIndex, change.newIndex);

          break;

        case 'set_color':
          if (field.selectOptions.options[change.index]) {
            field.selectOptions.options[change.index].color = change.color;
          }

          break;

        case 'update_label':
          field.selectOptions.options[change.index]?.applyLabelDelta(change.delta);

          break;
      }
    }
  });
}
